import React, { Component } from 'react';
import { observer, Provider } from 'mobx-react';
import { Link as ReachLink } from '@reach/router';
import { upperFirst } from 'lodash';

import ItemStore from 'js/stores/pages/AdminDashboardPage/ItemStore';
import { formatCurrency } from 'js/services/Format';
import { adminPanelColor } from 'js/config/style';

import LoadingSpinner from '../../LoadingSpinner';
import DashPanel from '../../DashPanel';
import Header from '../../DashPanel/Header';
import Content from '../../DashPanel/Content';
import DropMenu from '../../DashPanel/DropMenu';

import Link from './Link';
import Icon from './Icon';
import Title from './Title';
import Text from './Text';

import Card from './Card';
import Display from './Display';
import Image from './Image';
import Details from './Details';
import Label from './Label';
import Price from './Price';

import List from '../../List';
import Row from '../../List/Row';
import ListItem from '../../List/ListItem';
import ListMessage from '../../List/ListMessage';

import Order from './Order';
import User from '../../Display/User';
import LinkUsage from './LinkUsage';
import { default as OrderDisplay } from '../../Display/Order';

@observer
export default class Item extends Component {
  item = ItemStore.create({ alias: this.props['*'] });

  constructor(props) {
    super(props);
    this.item.load();
  }

  render() {
    const item = this.item;
    return (
      <DashPanel>
        <Header>
          <DropMenu />
          <Title>
            <Link to="/admin/items">Items</Link>
            {item.title && (
              <>
                <Icon name="chevron-right" />
                <Text>{item.title}</Text>
              </>
            )}
          </Title>
        </Header>

        <Provider model={item}>
          <Content background={adminPanelColor}>
            {this.item.isLoading ? (
              <LoadingSpinner />
            ) : (
              <>
                <Card>
                  <Display>
                    <Image src={item.image} />
                  </Display>

                  <Details>
                    <Label>Created</Label>
                    <div>{item.created_at}</div>

                    <Label>Item</Label>
                    <div>
                      {item.title} ({upperFirst(item.size)})
                    </div>

                    <Label>Address</Label>
                    <div>{item.item_address}</div>

                    <Label>Price</Label>
                    <div>
                      <Price>{formatCurrency(item.price)}</Price>
                    </div>
                  </Details>
                </Card>

                <div>
                  <Row cols={2}>
                    <User load={{ email: item.seller_email }} title="Item seller" />
                    <OrderDisplay load={{ alias: item.alias }} title="Order" />
                  </Row>

                  <Row>
                    <List paginator={item.orders} title="Offers" icon="file-text" controls="pages">
                      <div>
                        {item.orders.orders.length ? (
                          item.orders.orders.map(order => (
                            <ListItem key={order.uid} to={`/admin/orders/order/${order.uid}`}>
                              <Order order={order} />
                            </ListItem>
                          ))
                        ) : (
                          <ListMessage>No offers found</ListMessage>
                        )}
                      </div>
                    </List>
                  </Row>

                  <Row>
                    <List paginator={item.item_usage_logs} title="Link usage" icon="file-text">
                      <div>
                        {item.item_usage_logs.length ? (
                          item.item_usage_logs.map((log, index) => (
                            <ListItem key={index} to={log.user_email ? `/admin/users/user/${log.user_email}` : null}>
                              <LinkUsage log={log} />
                            </ListItem>
                          ))
                        ) : (
                          <ListMessage>Not used so far</ListMessage>
                        )}
                      </div>
                    </List>
                  </Row>

                </div>
              </>
            )}
          </Content>
        </Provider>
      </DashPanel>
    );
  }
}
